import LocalActivityIcon from "@mui/icons-material/LocalActivity"
import { Box, styled, Typography } from "@mui/material"
import TicketTypeCard from "components/conventions/TicketTypeCard"
import ConventionTicketType from "models/convention-api/v1/ConventionTicketType"
import React, { useMemo } from "react"
import { pxToRem } from "utils/helpers"

interface TicketTypesListProps {
  ticketTypes: ConventionTicketType[]
}

const TicketTypesList = (props: TicketTypesListProps) => {
  const { ticketTypes } = props
  const sortedTicketTypes = useMemo(
    () => ticketTypes.sort((a, b) => a.end_at.diff(b.end_at)),
    [ticketTypes],
  )

  return (
    <_Container>
      <_HeaderContainer>
        <LocalActivityIcon aria-hidden="true" />
        <Typography variant="header5">Tickets</Typography>
      </_HeaderContainer>
      <_List>
        {sortedTicketTypes.map((ticketType) => (
          <_ListItem key={ticketType.id}>
            <TicketTypeCard ticketType={ticketType} />
          </_ListItem>
        ))}
      </_List>
    </_Container>
  )
}

export default TicketTypesList

const _Container = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: pxToRem(22),
}))

const _HeaderContainer = styled(Box)(() => ({
  display: "flex",
  flexFlow: "row nowrap",
  gap: pxToRem(12),
  alignItems: "center",
}))

const _List = styled("ul")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: pxToRem(20),
  minWidth: pxToRem(210),
  margin: 0,
  padding: 0,
  listStyleType: "none",
}))

const _ListItem = styled("li")(() => ({}))
